import { formatDateTime } from './common'
import { t } from '../i18n/lingua'

/**
 * «Questi dati sono di ieri»: quando una lettura dal vivo è servita dalla
 * copia del Control Plane, si dice quando è stata raccolta e che «Aggiorna»
 * interroga di nuovo. Se l'ultimo tentativo è fallito, i dati di prima
 * restano — con il motivo accanto.
 */
export function NotaCache({ dati }: { dati: { cached?: boolean; fetched_at?: string; stale_reason?: string; refreshing?: boolean } | null | undefined }) {
  if (dati?.refreshing) {
    return (
      <p className="muted eagle-piccolo" style={{ margin: '0 0 8px' }}>
        {t('Interrogo i sistemi in sottofondo: la pagina si aggiorna da sola appena arrivano i dati nuovi.')}
        {dati.fetched_at && <> {t('Intanto vedi i dati raccolti il {quando}.', { quando: formatDateTime(dati.fetched_at) })}</>}
      </p>
    )
  }
  if (!dati?.cached || !dati.fetched_at) return null
  if (dati.stale_reason) {
    return (
      <p className="banner banner--warn">
        {t('L’ultimo aggiornamento non è riuscito ({motivo}): questi sono i dati raccolti il {quando}.', { motivo: dati.stale_reason, quando: formatDateTime(dati.fetched_at) })}
      </p>
    )
  }
  return (
    <p className="muted eagle-piccolo" style={{ margin: '0 0 8px' }}>
      {t('Dati raccolti il {quando}: premi «Aggiorna» per interrogare di nuovo.', { quando: formatDateTime(dati.fetched_at) })}
    </p>
  )
}
